<template>
    <form :id="`cludo-search-form-${searchBoxId}`"
          class="cludo-search-form"
          role="search"
          ref="form"
          >

        <div class="input-group lp-search-input d-flex">
            <label :for="`cludo-search-input-${searchBoxId}`"
                   class="visually-hidden">
                Search box
            </label>

            <input type="search"
                   :class="styleClasses"
                   aria-label="Search"
                   :id="`cludo-search-input-${searchBoxId}`"
                   :name="`cludo-search-input-${searchBoxId}`"
                   ref="searchBox"
                   @click="onFocus"
                   @focus="onFocus"
                   @focusout="onFocusOut" 
            />
            <div @click="focusInput">
                <i class="far fa-search lp-search-input__icon me-2"></i>
            </div>
            <div @click="clearSearch" class="clear-search ps-2 ps-lg-6 pt-3"></div>
        </div>
    </form>
</template>
<script>
    import { v4 as uuid } from 'uuid';
    import { onMounted, ref, reactive } from 'vue';

    export default {
        props: {
            customerId: {
                type: String,
                required: true,
            },
            engineId: {
                type: String,
                required: true,
            },
            searchUrl: {
                type: String,
                required: true,
            },
        },
        setup(props) {
            const searchBoxId = uuid();
            const searchInput = ref(null);

            const styleClasses = reactive({
                'form-control': true,
                'login-search-input': true,
                'inactive': false
            });

            const onFocus = (event) => {
                styleClasses['inactive'] = false;
            }

            const onFocusOut = (event) => {
                styleClasses['inactive'] = true;
                searchInput.value = "";
            }

            const focusInput = () => {
                onFocus();
                document.querySelector(".login-search-input").focus();
            }

            const onClick = (event) => {
                //Simulate pressing enter
                const keyboardEvent = new KeyboardEvent('keydown', {
                    code: 'Enter',
                    key: 'Enter',
                    charCode: 13,
                    keyCode: 13,
                    view: window,
                    bubbles: true
                });

                document.querySelector(".login-search-input").dispatchEvent(keyboardEvent);
            }

            const settings = {
                customerId: props.customerId || 10001400,
                engineId: props.engineId || 10002303,
                searchUrl: props.searchUrl,
                language: 'en',
                searchInputs: [`#cludo-search-form-${searchBoxId}`],
                template: 'InlineBasic',
                focusOnResultsAfterSearch: false,
                type: 'inline',
                enableRelatedSearches: true
            };


            const clearSearch = () => {
                searchInput.value = "";
            }

            const cludo = new Cludo(settings);

            onMounted(() => {
                cludo.init();
                if (window.innerWidth < 720) {
                    styleClasses['inactive'] = true;
                }

            });

            return {
                searchBoxId,
                clearSearch,
                onFocus,
                onFocusOut,
                focusInput,
                onClick,
                styleClasses
            };
        },
    };
</script>